module.exports = "/_next/static/images/logo-6-b1eed3539270708609f68ea3f1c4192e.svg";